import React from 'react'
import PropTypes from 'prop-types'

const SatisfactionRatingBackwardSyncSetting = ({ onClickDeactivate }) => (
  <div>
    <button className="ui button" onClick={onClickDeactivate}>
      Remove integration
    </button>
  </div>
)

SatisfactionRatingBackwardSyncSetting.propTypes = {
  onClickDeactivate: PropTypes.func.isRequired,
}

export default SatisfactionRatingBackwardSyncSetting



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/ZendeskIntegrationSettings/SatisfactionRatingBackwardSyncSetting.js